export default __webpack_public_path__ + "static/media/Latha.f5720782.ttf";